import {tko, cadastr, garbage, entity} from '../../../../api/api-endpoints.js'
import {tkoOffline} from '../../../../api/api-offline-endpoints.js'
import year from  '../../../../utils/year.js'
import {PERMS} from '../../../../config/permissions.js'
import {ProcessingId, UtilizationId, NeutralizationId} from '../../../../config/config'

export default {
  props: {
    id: null,
    itemId: null,
    tabView: null,
    fields: Object,
    formDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      operationType: null,
      year: year.getCurrentYear(),
      search: '',
      searchModel: ''
    }
  },
  computed: {
    showInputProduct () {
      return this.fields && this.fields.tkoActions && (
        this.fields.tkoActions.indexOf(ProcessingId) > -1
        || this.fields.tkoActions.indexOf(UtilizationId) > -1
        || this.fields.tkoActions.indexOf(NeutralizationId) > -1
      )
    },
    selectListOptions () {
      let menuItems = [
        {
          id: 'detail',
          name: 'Движение отходов'
        },
        {
          id: 'input',
          name: 'Сведения о полученных отходах'
        },
        {
          id: 'output',
          name: 'Сведения о переданных отходах'
        }
      ]
      if (this.showInputProduct) {
        menuItems.push({
          id: 'product',
          name: 'Полученная продукция'
        })
      }
      return menuItems
    },
    enabledActions () {
      if (this.formDisabled) {
        return []
      } else {
        return [PERMS.EDIT, PERMS.CREATE, PERMS.DELETE]
      }
    },
    editDisabled () {
      return this.formDisabled
    },
    tableInOnlineMode () {
      return this.itemId
    },
    enableOnAdd () {
      return ['fkkoName', 'code', 'total', 'count', 'measure_id']
    },
    garbageDetailAttr () {
      return {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: 'Введите код',
          validationRulePattern: '^((\\d*\\s*)*)$',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        danger: {
          label: 'Класс опасности',
          placeholder: 'цифра',
          required: true,
          validationRulePattern: '^([1-5])$'
        },
        start_year_value: {
          label: 'Количество на начало года, тонн'
        },
        start_year_value_cubic: {
          label: 'Количество на начало года, м<sup>3</sup>'
        },
        formed: {
          label: 'Образовано, тонн'
        },
        formed_cubic: {
          label: 'Образовано, м<sup>3</sup>'
        },
        input: {
          label: 'Поступило всего, тонн'
        },
        input_cubic: {
          label: 'Поступило всего, м<sup>3</sup>'
        },
        used: {
          label: 'Использовано, тонн'
        },
        used_cubic: {
          label: 'Использовано, м<sup>3</sup>'
        },
        processed: {
          label: 'Обработано, тонн'
        },
        processed_cubic: {
          label: 'Обработано, м<sup>3</sup>'
        },
        utiled: {
          label: 'Утилизировано всего, тонн'
        },
        utiled_cubic: {
          label: 'Утилизировано всего, м<sup>3</sup>'
        },
        utiled_to_recycle: {
          label: 'Утилизировано в т.ч. с целью рециклинга, тонн'
        },
        utiled_to_recycle_cubic: {
          label: 'Утилизировано в т.ч. с целью рециклинга, м<sup>3</sup>'
        },
        utiled_from_process: {
          label: 'Утилизировано в т.ч. после обработки, тонн'
        },
        utiled_from_process_cubic: {
          label: 'Утилизировано в т.ч. после обработки, м<sup>3</sup>'
        },
        neutral: {
          label: 'Обезврежено всего, тонн'
        },
        neutral_cubic: {
          label: 'Обезврежено всего, м<sup>3</sup>'
        },
        neutral_from_process: {
          label: 'Обезврежено в т.ч. после обработки, тонн'
        },
        neutral_from_process_cubic: {
          label: 'Обезврежено в т.ч. после обработки, м<sup>3</sup>'
        },
        output: {
          label: 'Передано всего, тонн'
        },
        output_cubic: {
          label: 'Передано всего, м<sup>3</sup>'
        },
        storage: {
          label: 'Размещено для хранения, тонн'
        },
        storage_cubic: {
          label: 'Размещено для хранения, м<sup>3</sup>'
        },
        burial: {
          label: 'Размещено для захоронения, тонн'
        },
        burial_cubic: {
          label: 'Размещено для захоронения, м<sup>3</sup>'
        },
        end_year_value: {
          label: 'Количество на конец года, тонн'
        },
        end_year_value_cubic: {
          label: 'Количество на конец года, м<sup>3</sup>'
        }
      }
    },
    garbageInputAttr () {
      return {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: ' ',
          disabled: true,
          validationRulePattern: '^((\\d*\\s*)*)$'
        },
        organizationName: {
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название',
          label: 'Организация-поставщик',
          suggestion: {
            options: [],
            onSelect: this.onSelectInputOrganization,
            suggestionEndpoint: this.suggestionOrganizationEndpoint,
            transformSuggestions: this.transformOrganizationSuggestions
          }
        },
        total: {
          label: 'Количество отходов',
          required: true
        }
      }
    },
    garbageOutputAttr () {
      return {
        fkkoName: {
          label: 'Наименование',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название отхода',
          required: true,
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        code: {
          label: 'Код ФККО',
          required: true,
          placeholder: 'Введите код',
          validationRulePattern: '^((\\d*\\s*)*)$',
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions
          }
        },
        organization: {
          validationRulePattern: '(\\.*)',
          placeholder: '',
          label: 'Организация, которой переданы отходы'
        },
        direction: {
          label: 'Направление'
        },
        use: {
          label: 'Передано для использования'
        },
        transport: {
          label: 'Передано для транспортирования'
        },
        processing: {
          label: 'Передано на обработку'
        },
        utilization: {
          label: 'Передано на утилизацию'
        },
        neutralization: {
          label: 'Передано для обезвреживания'
        },
        storage: {
          label: 'Передано на хранение'
        },
        burial: {
          label: 'Передано на захоронение'
        },
        total: {
          label: 'Всего',
          required: true
        }
      }
    },
    garbageInputProductAttr () {
      return {
        okpdCode: {
          required: true,
          label: 'Код ОКПД2',
          placeholder: 'Начните вводить цифры кода',
          validationRulePattern: '(\\.*)',
          suggestion: {
            options: [],
            onSelect: this.onSelectOKPD,
            suggestionEndpoint: this.suggestionOKPDEndpoint,
            transformSuggestions: this.transformOKPDSuggestions
          }
        },
        okpdName: {
          disabled: true,
          required: true,
          label: 'Наименование продукции',
          placeholder: ' ',
          validationRulePattern: '(\\.*)'
        },
        sum: {
          required: true,
          label: 'Количество'
        },
        measure_id: {
          required: true,
          label: 'Единица измерения',
          select: {
            options: [
              {id: 10, name: 'тонн'},
              {id: 17, name: 'шт.'},
              {id: 18, name: 'м³'},
            ],
            disablePlaceholderOption: true
          },
          validationRulePattern: '(\\.*)',
          onSelect: this.onSelectMeasure,
          transform: (model) => (this.measureOptions.find(mO => mO.id === model.measure_id) || {}).name
        },
        number: {
          required: true,
          label: 'Номер сертификата',
          placeholder: ' ',
          validationRulePattern: '(\\.*)'
        },
        organizationName: {
          required: true,
          label: 'Организация-получатель',
          placeholder: 'Начните вводить название',
          validationRulePattern: '(\\.*)',
          suggestion: {
            options: [],
            onSelect: this.onSelectInputProductOrganization,
            suggestionEndpoint: this.suggestionOrganizationEndpoint,
            transformSuggestions: this.transformOrganizationSuggestions
          }
        },
        techName: {
          required: true,
          label: 'Технология',
          placeholder: 'Начните вводить название',
          validationRulePattern: '(\\.*)',
          suggestion: {
            options: [],
            onSelect: this.onSelectTech,
            suggestionEndpoint: this.suggestionTechEndpoint,
            transformSuggestions: this.transformTechSuggestions
          }
        }
      }
    },
    measureOptions () {
      return [
        {id: 10, name: 'тонн'},
        {id: 17, name: 'шт.'},
        {id: 18, name: 'м³'},
      ];
    },
    garbageDataUrl () {
      if (this.tableInOnlineMode) {
        let routeQuery = {
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType
          }
        }
        if (this.search) {
          routeQuery.query.q = this.search
        }

        return tko.objectGarbageOperation(routeQuery)
      }
      // if new record, offline save
      return tkoOffline.objectGarbageTable(this.$route.name, this.year, this.operationType)
    },
    techDataUrl () {
      if (this.tableInOnlineMode) {
        return tko.objectTechOperation(this.id)
      }
      return tkoOffline.objectTechTable(this.$route.name)
    },
    techItems () {
      let data = this.$store.getters.readUrlEndpoint(this.techDataUrl)
      if (data && data.data) {
        return data.data
      }
      return []
    },
    techItemsIds () {
      return this.techItems.map(v => +v.tech_id)
    }
  },
  methods: {
    onSelectMeasure (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.measure_id = copy.id
        model.labelFormeasure_id = copy.name
      } else {
        model.measure_id = ''
        model.labelFormeasure_id = ''
      }
    },
    onSelectInputOrganization (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.organization_id = copy.id
        model.organizationName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.organization_id = ''
        model.organizationName = ''
      }
    },
    onSelectTech (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tech_id = copy.id
        model.techName = copy.name
      } else {
        model.tech_id = ''
        model.techName = ''
      }
    },
    suggestionTechEndpoint(ctx, q) {
      return cadastr.techs({
        query: {
          q,
          'per-page': -1,
          tkoObjectId: this.id || ''
        }
      })
    },
    transformTechSuggestions (ctx, response) {
      let data = response.data
      let options = []
      console.log('techItemsIds', this.techItemsIds)
      for (let i = 0; i < data.length; i++) {
        if (this.techItemsIds.indexOf(+data[i].id) > -1) {
          options.push({
            name: `${data[i].name}`,
            id: data[i].id
          })
        }
      }
      return options
    },
    onSelectOKPD (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.okpd_id = copy.id
        model.okpdCode = copy.okpdCode
        model.okpdName = copy.okpdName
      } else {
        model.okpd_id = ''
        model.okpdCode = ''
        model.okpdName = ''
      }
    },
    suggestionOKPDEndpoint (ctx, q) {
      return cadastr.okpd({query: {q, 'per-page': 50}})
    },
    transformOKPDSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: `${data[i].value} ${data[i].name}`,
          okpdName: data[i].name,
          okpdCode: data[i].value,
          id: data[i].id
        })
      }
      return options
    },
    onSelectInputProductOrganization (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.organization_id = copy.id
        model.organizationName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.organization_id = ''
        model.organizationName = ''
      }
    },
    suggestionOrganizationEndpoint (ctx, q) {
      return garbage.garbages({query: {q, 'per-page': 50}})
    },
    transformOrganizationSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    onSelectTKO (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.tko_object_id = copy.id
        model.tkoObjectName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.tko_object_id = ''
        model.tkoObjectName = ''
      }
    },
    suggestionTKOEndpoint (ctx, q) {
      return tko.objects({query: {q: q, 'per-page': 50}})
    },
    transformTKOSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].id + ' ' + data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    onSelectEntity (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.entity_id = copy.id
        model.entityName = this.$options.filters.stripHtml(copy.name)
      } else {
        model.entity_id = ''
        model.entityName = ''
      }
    },
    suggestionEntityEndpoint (ctx, q) {
      return entity.entities({query: {q: q, 'per-page': 50}})
    },
    transformEntitySuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].name,
          id: data[i].id
        })
      }
      return options
    },
    afterValidate (ctx, model, errors, els) {
      let {tr} = els
      if (errors.danger) {
        delete errors.danger
        errors.danger = 'Укажите Класс опасности: число от 1 до 5'
      }
      if (errors.code) {
        delete errors.code
        errors.fkkoName = 'Выберите отход'
      }

      if (errors.fkkoName) {
        if (tr) {
          try {
            tr.querySelectorAll('input')[0].focus()
          } catch (e) {
            console.error(e)
          }
        }
      }
  
      if (errors.danger) {
        if (tr) {
          try {
            tr.querySelectorAll('input')[2].focus()
          } catch (e) {
            console.error(e)
          }
        }
      }

      if (model.organizationName && !model.organization_id) {
        errors.organizationName = 'Выберите организацию'
        this.focusOnField(tr, 'organizationName')
      }
      if (model.okpdCode && !model.okpd_id) {
        errors.okpdCode = 'Выберите код'
        this.focusOnField(tr, 'okpdCode')
      }
      if (model.techName && !model.tech_id) {
        errors.techName = 'Выберите технологию'
        this.focusOnField(tr, 'techName')
      }

      return errors
    },
    focusOnField (tr, name) {
      try {
        console.log(tr)
        tr.querySelector('[name="' + name + '"]').focus()
      } catch (e) {
        console.error(e)
      }
    },
    afterFetchData (ctx, data) {
      for (let i = 0; i < data.data.length; i++) {
        data.data[i].garbage_type = 'default'
        if (data.data[i].fkko) {
          data.data[i].fkkoName = data.data[i].fkko.name

          if (!data.data[i].code) {
            data.data[i].code = data.data[i].fkko.code
          }
        } else {
          data.data[i].fkkoName = ''
        }
        if (data.data[i].organization && data.data[i].organization_id) {
          data.data[i].organizationName = data.data[i].organization.name
        }
        if (data.data[i].okpd && data.data[i].okpd_id) {
          data.data[i].okpdCode = data.data[i].okpd.value
          data.data[i].okpdName = data.data[i].okpd.name
        }
        if (data.data[i].tech && data.data[i].tech_id ) {
          data.data[i].techName = data.data[i].tech.name
        }
        if (data.data[i].tko_object_id && data.data[i].tkoObject) {
          data.data[i].tkoObjectName = data.data[i].tkoObject.name
        }

        if (data.data[i].entity_id && data.data[i].entity) {
          data.data[i].entityName = data.data[i].entity.name
        }
        if (data.data[i].product && data.data[i].product_id) {
          data.data[i].measure_id = data.data[i].product.measure_id
        }
      }

      // console.log(data.data)
      return data
    },
    onSelect (ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.code = copy.code
        model.fkko_id = copy.id
        model.fkkoName = copy.fkkoName
        model.danger = copy.danger
      } else {
        model.code = ''
        model.fkko_id = ''
        model.fkkoName = ''
        model.fkko = {name: ''}
        model.danger = ''
      }
    },
    suggestionEndpoint (ctx, q) {
      return cadastr.fkko({query: {q: q, 'per-page': 50}})
    },
    transformSuggestions (ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        options.push({
          name: data[i].code + ' ' + data[i].name,
          fkkoName: data[i].name,
          id: data[i].id,
          code: data[i].code,
          danger: data[i].danger
        })
      }
      return options
    },
    garbagePostUrl () {
      return tko.objectGarbageOperationPost({
        query: {
          sourceId: this.id,
          year: this.year,
          type: this.operationType
        }
      })
    },
    garbagePatchUrl (context, model) {
      return tko.objectGarbageOperationPatch({
        query: {
          tkoObjectId: this.id,
          sourceId: model.id,
          year: model.year,
          type: this.operationType
        }
      })
    },
    garbageDeleteUrl (context, model) {
      return tko.objectGarbageOperationDelete({
        query: {
          sourceId: model.id,
          year: model.year,
          type: this.operationType
        }
      })
    },
    // if you dont see rows
    // server send get responses in wrong format
    // on 18 june actual for detail and output
    addNewRowToGarbageTable () {
      const Model = () => {
        return {
          okpd_id: '',
          code: '',
          danger: '',
          tko_object_id: '',
          tkoObjectName: '',
          entity_id: '',
          entityName: '',
          // can be used for turn year select
          _operationType: JSON.parse(JSON.stringify(this.operationType)),
          _year: JSON.parse(JSON.stringify(this.year))
        }
      }
      if (this.operationType === 'detail') {
        this.$refs.detail.createRow(new Model())
      } else if (this.operationType === 'input') {
        this.$refs.input.createRow(new Model())
      } else if (this.operationType === 'output') {
        this.$refs.output.createRow(new Model())
      } else if (this.operationType === 'product') {
        this.$refs.inputProduct.createRow(new Model())
      }
    }
  }
}
